<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Copy Form</span>
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" >
      <div class="input-container">
          <span class="label">Form Name <span class="red-text"></span></span>
          
          <input [(ngModel)]="formName" type="text" placeholder="Form Name" required class="get-Input">
      </div>
  </div>

  <div class="ttmodal__footer" >
      <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
      <button class="button button--primary" (click)="onCopyForm()" [disabled]="disable">Copy Form</button>
      <!-- <a class="button button--primary" (click)="onCopyForm()" [disabled]="disable"><span class="button__text">Copy Form</span></a> -->
  </div>
</div>